import React, { useState, useEffect } from "react";
import classNames from "classnames";
import HotspotCarousel from "../hotspot-carousel";
import TabMenu from "../tab-menu";
import BodyText from "../../elements/body-text";
import Heading from "../../elements/heading";
import "./style.scss";

const HotspotWithTabMenu = ({ gridType, componentPadding, alignContent, backgroundColor, hotspotCollectionProps, tabMenu, textContent = {}, initialTab = 0, initialOption = 0, initialImage = 0 }) => {
  const [hotspotCollection] = useState(hotspotCollectionProps);
  const [currentOptions, setOptions] = useState(hotspotCollection[initialTab].options);
  const [currentImages, setImages] = useState(hotspotCollection[initialTab].options[initialOption].images);
  const [currentImageIndex, setImageIndex] = useState(initialImage);
  const [resetCarousel, setCarouselReset] = useState(false);
  const [tabData, setTabItems] = useState({
    selectedTabIndex: initialTab,
    selectedOptionIndex: initialOption
  });

  const getOptions = tabLabel => {
    const selectedOptions = hotspotCollection.filter(group => group.tab.toLowerCase() === tabLabel.toLowerCase());
    return (selectedOptions[0] && selectedOptions[0].options) || currentOptions;
  };

  const tabCallback = (event, tab, option = {}) => {
    // Example of tab callback useage
    if (tabData.selectedTabIndex !== tab.index) {
      setOptions(getOptions(tab.label));
      setCarouselReset(true);
    } else if (tabData.selectedOptionIndex !== option.index) {
      setCarouselReset(true);
    }
    setTabItems({
      selectedTabIndex: tab.index,
      selectedOptionIndex: option.index || 0
    });
  };

  useEffect(() => {
    setImages(currentOptions[tabData.selectedOptionIndex].images);
    setCarouselReset(false);
  }, [setImages, currentOptions, tabData]);

  const handlePageChange = ({ index }) => setImageIndex(index);

  const tabbedHotspotContainerClasses = classNames("tabbed-hotspot-container", `padding-top-${(componentPadding && componentPadding.top) || "default"}`, `padding-bottom-${(componentPadding && componentPadding.bottom) || "default"}`, {
    "grid-story": gridType === "story",
    grid: gridType === "normal"
  });

  const headingClasses = classNames(alignContent);
  const bodyTextClasses = classNames("body", alignContent);

  return (
    <div className={tabbedHotspotContainerClasses} style={{ backgroundColor: backgroundColor }}>
      {textContent.heading && <Heading className={headingClasses} type={textContent.heading.type} html={textContent.heading.text} typographyClass={textContent.heading.typographyClass ? textContent.heading.typographyClass : "type-h1"} />}
      {textContent.body && <BodyText className={bodyTextClasses} html={textContent.body} />}
      <TabMenu tabMenu={tabMenu} onTabClicked={tabCallback} selectedTabIndex={tabData.selectedTabIndex} selectedOptionIndex={tabData.selectedOptionIndex} />
      <HotspotCarousel key={Math.random()} initialIndex={currentImageIndex} items={currentImages} onPageChange={handlePageChange} forceReset={resetCarousel} />
    </div>
  );
};

export default HotspotWithTabMenu;
